<template>
  <section class="component-mini-basket">
    <div class="basket-icon position-relative">
      <span class="badge badge-info shadow position-absolute badge-basket" v-if="lenghtBasketCard">{{lenghtBasketCard}}</span>
      <span class="mt-1 d-inline-block">
        <i @click="toggleBasket" class="flaticon-shopping-cart icon-35"></i>
      </span>
      <ul class="position-absolute list-basket card" v-if="open">
        <li v-for="(item,index) in basketList" :key="index" class="d-flex py-3 px-2  flex-row text-center rtl justify-content-around  ">
          <p class="align-self-center mb-0 text-truncate w-25">{{item.name}} </p>
          <p class="align-self-center mb-0">{{item.price | currency}}</p>
          <summary class="align-self-center text-danger mdi mdi-close" @click="remove(item,index)"> </summary>
        </li>
        <div v-on:click.stop.prevent="open = false" class="display-block">
          <router-link tag="button" to="/v1/basket" class="bttn-jelly  bttn btn-block rounded bttn-primary" v-ripple :title="$t('button.listCard')">
            <i class=" mdi mdi-cart-outline"></i>
            {{$t('button.listCard')}}
          </router-link>
        </div>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'minibasket',
  components: {
  },
  data () {
    return {
      open: false
    }
  },
  computed: {
    lenghtBasketCard () {
      return this.$store.state.basket.lenghtBasketCard
    },
    basketList () {
      return this.$store.state.basket.basketList
    }
  },
  mounted () {
    // this.$refs.basketBox
  },
  methods: {
    toggleBasket () {
      if (this.basketList.length == 0) {
        this.$root.showInfoMsg({
          title: 'لیست خرید',
          message: `${this.user.fullname} عزیز لیست خرید شما خالی میباشد`
        })
        return
      }
      this.open = !this.open
    },
    remove (item, index) {
      this.$delete(this.basketList, index)
      this.$store.commit("basket/SET_DATA", { data: this.basketList.length, id: "lenghtBasketCard" });

      if (this.basketList.length == 0) {
        this.open = false
      }
      localStorage.setItem('shoppingCard', JSON.stringify(this.basketList))
    }
  }
}
</script>

<style lang="less">
@import (reference) "../../../assets/css/variable.less";
.component-mini-basket {
  .box-clear;
  .basket-icon {
    position: relative;
    i {
      cursor: pointer;
      color : @blue;
      &:hover{
        color: @green;
      }
    }
    > button {
      width: 50px;
    }
  }
  .badge-basket {
    right: -12px;
    top: 5px;
    width: 20px;
    height: 20;
    z-index: 6;
    // border-radius: 100%;
    // text-align: center;
  }
  .list-basket {
    width: 300px;
    left: 0;
    li {
      border-bottom: 1px solid @green;
      font-size: 14px;
      &:last-child {
        border-bottom: none;
      }
    }
  }
  button {
    font-size: 14px;
  }
}
// .component-mini-basket .list-basket{}
</style>



// WEBPACK FOOTER //
// src/components/ui/basket/basket.vue